module.exports = __webpack_public_path__ + "img/slider_18.8d131844.jpg";